export default __webpack_public_path__ + "static/media/TC_Logo_vert.e0d2e6ad.png";